import { FunctionComponent, lazy, Suspense } from 'react'

import { LoadingTurbo } from 'atoms'
import { OpportunityDTO } from 'integration/resources/wallet'

import { PANELS_TYPES_ENUM } from './constants'

type TabPanelsProps = {
  handleGoToFullChartScreen(type: PANELS_TYPES_ENUM): void
  tabNumber: string
  opportunity?: OpportunityDTO | null
  isTabLoading?: boolean
  yearMonthFilterOptions?: { value: string; label: string }[]
  selectedYearMonth?: string
  onChangeYearMonthFilter?(value: string): void
}

const TabPanelsMobile = lazy(() => import('./TabPanels.mobile'))

export const TabPanels: FunctionComponent<TabPanelsProps> = (props) => {
  const Component = TabPanelsMobile

  return (
    <Suspense fallback={<LoadingTurbo />}>
      <Component {...props} />
    </Suspense>
  )
}
